/** Centros aproximados para seleção manual; não representam a posição do usuário. */
export interface PortugueseCity {
  readonly id: string;
  readonly name: string;
  readonly district: string;
  readonly lat: number;
  readonly lng: number;
}

export const PT_CITIES = [
  { id: 'aveiro', name: 'Aveiro', district: 'Aveiro', lat: 40.641, lng: -8.654 },
  { id: 'beja', name: 'Beja', district: 'Beja', lat: 38.016, lng: -7.864 },
  { id: 'braga', name: 'Braga', district: 'Braga', lat: 41.551, lng: -8.423 },
  { id: 'braganca', name: 'Bragança', district: 'Bragança', lat: 41.807, lng: -6.758 },
  { id: 'castelo-branco', name: 'Castelo Branco', district: 'Castelo Branco', lat: 39.822, lng: -7.491 },
  { id: 'coimbra', name: 'Coimbra', district: 'Coimbra', lat: 40.205, lng: -8.419 },
  { id: 'evora', name: 'Évora', district: 'Évora', lat: 38.571, lng: -7.909 },
  { id: 'faro', name: 'Faro', district: 'Faro', lat: 37.019, lng: -7.931 },
  { id: 'guarda', name: 'Guarda', district: 'Guarda', lat: 40.538, lng: -7.268 },
  { id: 'leiria', name: 'Leiria', district: 'Leiria', lat: 39.745, lng: -8.807 },
  { id: 'lisboa', name: 'Lisboa', district: 'Lisboa', lat: 38.722, lng: -9.139 },
  { id: 'portalegre', name: 'Portalegre', district: 'Portalegre', lat: 39.293, lng: -7.431 },
  { id: 'porto', name: 'Porto', district: 'Porto', lat: 41.149, lng: -8.611 },
  { id: 'santarem', name: 'Santarém', district: 'Santarém', lat: 39.236, lng: -8.686 },
  { id: 'setubal', name: 'Setúbal', district: 'Setúbal', lat: 38.524, lng: -8.889 },
  { id: 'viana-do-castelo', name: 'Viana do Castelo', district: 'Viana do Castelo', lat: 41.694, lng: -8.832 },
  { id: 'vila-real', name: 'Vila Real', district: 'Vila Real', lat: 41.301, lng: -7.744 },
  { id: 'viseu', name: 'Viseu', district: 'Viseu', lat: 40.661, lng: -7.909 },
  { id: 'funchal', name: 'Funchal', district: 'Madeira', lat: 32.65, lng: -16.908 },
  { id: 'ponta-delgada', name: 'Ponta Delgada', district: 'Açores', lat: 37.741, lng: -25.675 },
] as const satisfies readonly PortugueseCity[];

export type PortugueseCityId = (typeof PT_CITIES)[number]['id'];
export const cityById = (id: string): PortugueseCity | undefined => PT_CITIES.find((city) => city.id === id);
export const cityByName = (name: string): PortugueseCity | undefined =>
  PT_CITIES.find((city) => city.name.localeCompare(name.trim(), 'pt-PT', { sensitivity: 'base' }) === 0);
